import { notify } from 'utils/reduxUtils';

export const types = {
  FETCH_QUOTE_WORKFLOW_ERROR: 'dashboard/workflows/FETCH_QUOTE_WORKFLOW_ERROR',
  FETCH_QUOTE_WORKFLOW_REQUEST:
    'dashboard/workflows/FETCH_QUOTE_WORKFLOW_REQUEST',
  FETCH_QUOTE_WORKFLOW_SUCCESS:
    'dashboard/workflows/FETCH_QUOTE_WORKFLOW_SUCCESS',
  FETCH_QUOTES_ERROR: 'dashboard/workflows/FETCH_QUOTES_ERROR',
  FETCH_QUOTES_REQUEST: 'dashboard/workflows/FETCH_QUOTES_REQUEST',
  FETCH_QUOTES_UPDATE: 'dashboard/workflows/FETCH_QUOTES_UPDATE',
  FETCH_QUOTES_SUCCESS: 'dashboard/workflows/FETCH_QUOTES_SUCCESS',
  QUOTE_SOCKET_INITIALIZE_REQUEST:
    'dashboard/workflows/QUOTE_SOCKET_INITIALIZE_REQUEST',
  WORKFLOWS_INIT: 'dashboard/workflows/WORKFLOWS_INIT',
  WORKFLOWS_FILTER: 'dashboard/workflows/WORKFLOWS_FILTER',
  WORKFLOWS_PAGINATE: 'dashboard/workflows/WORKFLOWS_PAGINATE',
  WORKFLOWS_UPDATE: 'dashboard/workflows/WORKFLOWS_UPDATE',
};

export const dashboard = {
  init: () => ({
    type: types.WORKFLOWS_INIT,
  }),
  update: ({ filters, page }) => ({
    type: types.WORKFLOWS_UPDATE,
    payload: { filters, page },
  }),
  filter: (filters) => ({
    type: types.WORKFLOWS_FILTER,
    payload: { filters },
  }),
  paginate: ({ pageNumber }) => ({
    type: types.WORKFLOWS_PAGINATE,
    payload: { pageNumber },
  }),
};

export const fetchQuotes = {
  error: notify(
    (error) => ({
      type: types.FETCH_QUOTES_ERROR,
      payload: error,
    }),
    'Error fetching quote workflows',
  ),
  request: () => ({
    type: types.FETCH_QUOTES_REQUEST,
  }),
  success: ({ quotes, totalCount }) => ({
    type: types.FETCH_QUOTES_SUCCESS,
    payload: { quotes, totalCount },
  }),
  update: () => ({
    type: types.FETCH_QUOTES_UPDATE,
  }),
};

export const fetchQuoteWorkflow = {
  error: notify(
    (error) => ({
      type: types.FETCH_QUOTE_WORKFLOW_ERROR,
      payload: error,
    }),
    'Error fetching quote workflows config',
  ),
  request: () => ({
    type: types.FETCH_QUOTE_WORKFLOW_REQUEST,
  }),
  success: ({ quoteWorkflow }) => ({
    type: types.FETCH_QUOTE_WORKFLOW_SUCCESS,
    payload: { quoteWorkflow },
  }),
};

export const quoteSocketInitialize = {
  request: () => ({
    type: types.QUOTE_SOCKET_INITIALIZE_REQUEST,
  }),
};
